import { IPrivileges } from '@/app/state/auth';
import { IRestPostDevice, TRestPutDevice } from '@/app/services/devices';
import { DEVICE_TYPES, TDeviceDialogType, TDeviceFormValues } from '../types';

const buildAttributes = (
    enabled: boolean,
    privileges: IPrivileges
): { eToll: boolean } | undefined => {
    return privileges.eToll || privileges.eTollEditRegistrationData
        ? { eToll: enabled }
        : undefined;
};

const buildIntegrations = (
    values: TDeviceFormValues,
    privileges: IPrivileges
) => {
    if (privileges.eTollEditRegistrationData) {
        const businessNumber = values.advanced.eToll.businessNumber;
        const pin = values.advanced.eToll.pin;

        if (businessNumber === undefined) {
            return undefined;
        }

        return {
            eToll: {
                businessNumber: businessNumber as string,
                pin: pin as string,
            },
        };
    }

    return undefined;
};

export const mapCreateDeviceFormValuesToPayload = (
    values: TDeviceFormValues,
    mode: TDeviceDialogType,
    privileges: IPrivileges
): IRestPostDevice | TRestPutDevice => {
    const canSetPassword = DEVICE_TYPES.find(
        (d) => d.id === values.data.deviceType
    )?.canSetPassword;

    const serialNumber =
        values.data.deviceType && values.data.deviceType !== 'other'
            ? `${values.data.deviceType}${values.data.serialNumber}`
            : values.data.serialNumber;

    if (mode === 'edit') {
        const payload: TRestPutDevice = {
            id: values.data.id || undefined,
            deviceData: privileges.editDevices
                ? {
                      serialNumber: serialNumber as string,
                      password: canSetPassword
                          ? values.data.password || undefined
                          : undefined,
                      monitoredObjectId:
                          values.data.monitoredObjectId?.id ?? undefined,
                  }
                : undefined,
            attributes: buildAttributes(
                values.advanced.eToll.enabled,
                privileges
            ),
            integrations: buildIntegrations(values, privileges),
        };
        return payload;
    }

    return {
        id: values.data.id || undefined,
        serialNumber: serialNumber as string,
        password: canSetPassword ? values.data.password || '' : undefined,
        monitoredObjectId: values.data.monitoredObjectId?.id ?? undefined,
        attributes: buildAttributes(values.advanced.eToll.enabled, privileges),
        integrations: buildIntegrations(values, privileges),
    };
};
